import styled from "styled-components";

import { TEXT_PRIMARY, TEXT_SECONDARY } from "../../colors";
import { Caps, Caption } from "../../typography";

export const Label = styled(Caps).attrs({
  as: "label"
})`
  color: ${({ isFocused }) => (isFocused ? TEXT_PRIMARY : TEXT_SECONDARY)};
  margin: 0;
`;

export const Hint = styled(Caption).attrs({
  as: "span"
})`
  color: ${TEXT_SECONDARY};
  font-weight: normal;
  text-transform: none;
`;
